import styled from 'styled-components';
import Typography from '../../components/uielements/typography';
import Button from '@material-ui/core/Button';

export default {
  Heading: styled(Typography)`
    color: #424242;
    margin-bottom: 10px;
  `,
  LoadMoreButton: styled(Button)`
    width: 100%;
  `,
  ProgressWrapper: styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
  `,
}


// WEBPACK FOOTER //
// ./src/containers/Topbar/notificationSection.style.js